import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { State } from '../../../../vista-usuario/vista-usuario.state';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import { FormActionType, Pais } from '@rpe/registro-personas-empresas-lib';

import { entityMuestreadorAddRequest } from '../../entity-muestreador.actions';
import {
  Muestreador,
  MuestreadorFormInput
} from '../../entity-muestreador.model';
import { MuestreadorFormComponent } from '../muestreador-form/muestreador-form.component';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { selectAuthPersona } from '../../../../persona/entity-personas/entity-personas.selectors';
import { createEmptyDireccionGeografica } from '../../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

@Component({
  selector: 'rpe-entity-muestreador-form-container',
  templateUrl: './entity-muestreador-form-container.component.html',
  styleUrls: ['./entity-muestreador-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityMuestreadorFormContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild(MuestreadorFormComponent)
  muestreadorForm: MuestreadorFormComponent;

  paises$: Observable<Pais[]> | undefined;

  formValid = false;
  formValue: Muestreador;

  subscription: Subscription;

  // mover el form input para donde corresponda
  formInput: MuestreadorFormInput = {
    action: FormActionType.Add,
    direccion_geografica: createEmptyDireccionGeografica(),
    persona: null
  };

  constructor(
    public store: Store<State>,
    private ref: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription = this.store
      .pipe(
        select(selectAuthPersona),
        filter((personas) => !!personas)
      )
      .subscribe((persona) => {
        this.formInput = {
          action: FormActionType.Add,
          direccion_geografica: persona.direccion_geografica,
          persona: persona
        };
        this.ref.detectChanges();
      });
  }

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(muestreador: Muestreador) {
    this.formValue = muestreador;
  }

  onSubmit() {
    if (this.formValid) {
      if (this.formInput.action === FormActionType.Add) {
        this.formValue.tecnico.tipo_tecnico_id = 3;
        this.store.dispatch(
          entityMuestreadorAddRequest({
            item: this.formValue
          })
        );
      }
    } else {
      this.muestreadorForm.onShowErrors();
    }
  }

  onCancel() {
    this.router.navigate(['/main', 'landing']);
  }
}
